import { BaseUseCase } from "../UseCaseBase";
class LocateUsUseCase extends BaseUseCase {
    constructor(FooterRepository) {
        super();
        this.FooterRepository = FooterRepository;
    }
    fetchResult() {
        return this.FooterRepository.getlocateusMasterData();
    }
}
export default LocateUsUseCase;
